import React from 'react'
import Layout from '../../components/towerHeadAdmin/Layout'

function Dashboard() {
  return (
    <div>
      <Layout>
        <h1 className='text-2xl font-bold px-2'>Corporate Admin Dashboard</h1>

      </Layout>
    </div>
  )
}

export default Dashboard
